import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { lifecycle, compose } from 'recompose'

import {
  initRevisions
} from './actions'

const mapStateToProps = (state) => ({})

const mapDispatchToProps = (dispatch) => {
  return {
    initialize: () => dispatch(initRevisions())
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withMount = lifecycle({
  componentWillMount() { this.props.initialize() },
})

export default compose(
  withConnect,
  withMount,
)
